module.exports = __webpack_public_path__ + "static/media/grid_img3.4f26fe73.webp";